<template>
  <div class="notifications" :class="renderComponent ? 'block' : 'hidden'">
    <div v-if="visible">
      <div v-for="(notification, index) in notifications" :key="index">
        <q-banner
          rounded
          class="q-pa-sm q-mb-xs cursor-pointer"
          :class="notificationBgRenderClass(notification.notificationType)"
          v-if="notification.active"
          @click="toggleNotificationBar"
        >
          <template v-slot:avatar>
            <q-icon
              size="lg"
              :name="getIcon(notification.notificationType)"
              class="notifications__icon"
            />
          </template>
          {{ notification.message }}
        </q-banner>
      </div>
    </div>

    <div v-else>
      <q-btn
        size="md"
        label="Show Notifications"
        flat
        color="secondary"
        icon="warning"
        @click="toggleNotificationBar"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SiteNotifications",

  data() {
    return {
      notifications: [],
      visible: true,
      renderComponent: false,
    }
  },
  methods: {
    notificationBgRenderClass(type) {
      switch (type) {
        case "Urgent":
          return "bg-red-6"

        case "Disruption":
          return "bg-blue-8"

        default:
          return "bg-yellow-8"
      }
    },

    toggleNotificationBar() {
      this.visible = !this.visible
    },
    async fetchSiteNotifications() {
      // Link is the id we want to target from Strapi to generate our response
      const payload = {
        link: "site-notifications",
      }

      await this.$store
        .dispatch("fetchSiteNofitications", payload)
        .then((response) => {
          // Assign response to this.categories to allow markup to look through objects
          if (response && response.data) {
            this.notifications = response.data.filter((item) => item.active)

            if (this.notifications.length > 0) {
              this.visible = true
              this.renderComponent = true
            } else {
              this.visible = false
              this.renderComponent = false
            }
          }
        })
        .catch((error) => {
          this.errors.push(error)
          console.log("error from notifications", error)
        })
    },
    getIcon(type) {
      if (type == "Urgent") {
        return "highlight_off"
      } else if (type == "Disruption") {
        return "error_outline"
      } else {
        return "help_outline"
      }
    },
  },

  mounted() {
    this.fetchSiteNotifications()
  },
}
</script>

<style lang="scss" scoped>
.notifications {
  background: white;
  padding: 1rem;
  width: 100%;

  &__content {
    display: flex;
    display: flex;
    flex-direction: column;
  }
  &__message {
    display: flex;
    font-weight: 500;
    font-size: 12px;
    padding: 5px 0;
  }
  &__icon.information {
    color: var(--q-color-secondary);
  }
  &__icon.disruption {
    color: var(--q-color-warning);
  }
  &__icon.urgent {
    color: var(--q-color-negative);
  }
  &__text {
    color: black;
  }
}
.body {
  &--dark {
    .notifications {
      background: black;
      &__text {
        color: #fff;
      }
    }
  }
}
</style>
